import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('AddressInput', () => {
      return Promise.all([
        import('./viewer/AddressInput' /* webpackChunkName: "AddressInput" */),
        import(
          './viewer/AddressInput.controller' /* webpackChunkName: "AddressInput" */
        ),
      ]).then(([componentModule, controllerModule]) => {
        return {
          component: componentModule.default,
          controller: controllerModule.default,
        };
      });
    });
  },
};

export default entry;
